"use client";

import { createContext, useContext } from "react";

/**
 * What the left menu tells the content it hosts (the streams filters come from the home page's @sidebar
 * slot): whether it is expanded (labels shown) or a slim icon rail, and how to close it after a choice.
 */
export const SidebarContext = createContext<{ expanded: boolean; onNavigate: () => void }>({ expanded: true, onNavigate: () => {} });

export const useSidebar = () => useContext(SidebarContext);
